export const tr = {
    add: 'Ekle',
    'audio-disable-reason': 'Videodaki ses kullanılıyor',
    cancel: 'İptal',
    converting: 'İşleniyor',
    crop: 'Kırp',
    edit: 'Düzenle',
    'idea-source': 'Sayfada farklı seçim yap',
    'library-source': 'Görsel galerisinden seç',
    'link-source': 'URL adresini kullan',
    'recent-source': 'Daha önce yüklenenlerden seç',
    'smart-center': "Akıllı Merkez'i kur",
    'upload-error': 'Dosya yüklenirken hata oluştu. Lütfen, az sonra tekrar deneyin.',
    'upload-source': 'Bilgisayardan yükle'
};
